var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('VueBotUI',{attrs:{"options":_vm.botOptions,"messages":_vm.messageData,"bot-typing":_vm.botTyping,"input-disable":_vm.inputDisable,"is-open":false},on:{"init":_vm.botStart,"msg-send":_vm.msgSend}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }